import type { CSSProperties } from 'react';

export const MONOSPACE_TEXTAREA_STYLE: CSSProperties = {
  width: '100%',
  boxSizing: 'border-box',
  fontFamily: 'monospace',
  fontSize: 13,
  lineHeight: 1.6,
  padding: '12px',
  border: '1px solid rgba(0,0,0,0.23)',
  borderRadius: 4,
  resize: 'vertical',
  outline: 'none',
  background: '#fafafa',
  color: 'inherit',
};

export const PRODUCTION_REFERENCE_SX = {
  mt: 1,
  p: 1.5,
  background: '#f5f5f5',
  borderRadius: 1,
  fontSize: '0.78rem',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  border: '1px solid',
  borderColor: 'divider',
  fontFamily: 'monospace',
} as const;
